import { render, staticRenderFns } from "./RebookingTab.vue?vue&type=template&id=2b724edb&scoped=true"
import script from "./RebookingTab.vue?vue&type=script&lang=js"
export * from "./RebookingTab.vue?vue&type=script&lang=js"
import style0 from "./RebookingTab.vue?vue&type=style&index=0&id=2b724edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b724edb",
  null
  
)

export default component.exports